import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Urls, { pusherEvent } from 'Containers/Urls';
import useProtectedApplication from 'Hooks/useProtectedApplication';
import useIsMounted from 'Utils/useIsMounted';
import Pusher from 'Utils/Pusher';

import { usePusherParams } from './usePusher.models';
import { usePusherRedirectionState } from './usePusherRedirectionState';
import { useRedirectionToast } from './useRedirectionToast';

export const usePusher = ({
  routeStatus,
} : usePusherParams) => {
  const { pathname } = useLocation();
  const history = useHistory();
  const isMounted = useIsMounted();
  const [pusherStatus, setPusherStatus] = useState('');
  const {
    refetch: refetchApplication,
  } = useProtectedApplication();

  const { isRedirectionEnabled } = usePusherRedirectionState();

  const {
    showRedirectMessage,
  } = useRedirectionToast();

  // useEffect in order to use updated isRedirectionEnabled and pathname values
  // due to async call of handlePusherStatus
  useEffect(() => {
    if (!pusherStatus) return;
    if (!isRedirectionEnabled) return;
    // Trigger overridden behavior when needed
    if (pusherStatus === 'overridden' || pusherStatus === 'cancelled') {
      const excludeRedirectionRoutes = [Urls.overridden, Urls.channels, Urls.instoreCustomer];
      if (excludeRedirectionRoutes.includes(pathname)) {
        setPusherStatus('');
        return;
      }
      setPusherStatus('');
      showRedirectMessage();
      history.replace(Urls.overridden);
      return;
    }

    if (routeStatus !== pusherStatus) {
      // Information is not up to date, refetch it
      setPusherStatus('');
      refetchApplication();
    }
  }, [pusherStatus]);

  const handlePusherStatus = (responsePusher = { status: '' }) => {
    if (!isMounted.current) return;
    setPusherStatus(responsePusher.status);
  };

  // Subscribe to state_change pusher
  useEffect(() => {
    Pusher({
      callback: handlePusherStatus,
      pusherEvent,
    });
  }, []);
};
